import React from "react";

class FixedWidgetContainer extends React.PureComponent {
  render() {
    const { bottom = 0, right = 0 } = this.props;
    return (
      <div
        className="pointer-events-none fixed m-2 flex flex-col items-end justify-end gap-3"
        style={{ zIndex: 2, bottom, right }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default FixedWidgetContainer;
